// src/client/renderer/shaders/stone-skin.ts

import * as THREE from 'three';
import type { ShaderFactory } from './types';
import { VERTEX as STONE_SKIN_VERTEX, FRAGMENT as STONE_SKIN_FRAGMENT } from './stone-skin.glsl';

export interface StoneSkinShaderUniforms {
  /** Mid-tone stone color. */
  uBaseColor: THREE.IUniform<THREE.Color>;
  /** Dark stone grain color. */
  uDarkColor: THREE.IUniform<THREE.Color>;
  /** Deep crack color. */
  uCrackColor: THREE.IUniform<THREE.Color>;
  /** Coarse rock grain scale. */
  uNoiseScale: THREE.IUniform<number>;
  /** Fine crack/vein scale. */
  uCrackScale: THREE.IUniform<number>;
  /** Vertex displacement amount along normals. */
  uDisplacement: THREE.IUniform<number>;
  /** Fade control for status enter/exit. */
  uOpacity: THREE.IUniform<number>;
}

export const createStoneSkinShader: ShaderFactory = () => {
  const uniforms: StoneSkinShaderUniforms = {
    uBaseColor: { value: new THREE.Color(0x8a8173) },
    uDarkColor: { value: new THREE.Color(0x4f4943) },
    uCrackColor: { value: new THREE.Color(0x1f1b18) },
    uNoiseScale: { value: 7.5 },
    uCrackScale: { value: 17.0 },
    uDisplacement: { value: 0.025 },
    uOpacity: { value: 1.0 },
  };

  return new THREE.ShaderMaterial({
    uniforms: uniforms as unknown as Record<string, THREE.IUniform<unknown>>,
    vertexShader: STONE_SKIN_VERTEX,
    fragmentShader: STONE_SKIN_FRAGMENT,
    transparent: true,
    depthWrite: true,
  });
};
